import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';
import { shadows } from '../shadows';

export const MuiTooltip: Components<Theme>['MuiTooltip'] = {
  defaultProps: {
    arrow: true,
  },
  styleOverrides: {
    tooltip: ({ theme }) => ({
      backgroundColor: colors.gray[950],
      color: colors.common.white,
      boxShadow: shadows[4], // shadow-lg
      borderRadius: theme.spacing(1),
      maxWidth: 240,
    }),
    arrow: {
      color: colors.gray[950],
    },
  },
};
